module.exports = __webpack_public_path__ + "static/media/bullet-curand.9d8af725.png";